import { request } from '../api';
import { useGameStore } from '../stores';
import { storeDidCatch } from '../utils';

const {
  setCompetitionModeData,
  setCompetitionModeResult,
  setIsFinishedCompetition,
  setRandomFact,
  setGeneralModeData,
  setGeneralModeResult,
  setCompetitionModeStatus,
  setGeneralModeStatus,
  setTrainingModeStatus,
  setTrainingModeData,
  setTrainingModeResult,
} = useGameStore.getState();

export const getCompetitionModeData = async () => {
  try {
    const { data: { data } = {} } = await request.post(
      '/game-server/competitive/location',
    );
    setCompetitionModeData(data);

    if (data.final) {
      setIsFinishedCompetition(true);
    }
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getCompetitionModeData]', error);
  }
};

export const postCompetitionResult = async (
  lat: number,
  lng: number,
  final: boolean,
) => {
  try {
    const { data: { data } = {} } = await request.post(
      '/game-server/competitive/guess',
      { guessedLatitude: lat, guessedLongitude: lng, final: final },
    );
    setCompetitionModeResult(data);

    if (data.final) {
      setIsFinishedCompetition(true);
    }
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [postCompetitionResult]', error);
  }
};

export const competitionFinalize = async () => {
  try {
    const { data: { data: { final } = {} } = {} } = await request.post(
      '/game-server/competitive/final',
      { final: true },
    );

    if (final) {
      setIsFinishedCompetition(true);
    }
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [competitionFinalize]', error);
  }
};

export const getGeneralModeData = async () => {
  try {
    const { data: { data } = {} } = await request.post(
      '/game-server/general/location',
    );
    setGeneralModeData(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getGeneralModeData]', error);
  }
};

export const postGeneralResult = async (lat: number, lng: number) => {
  try {
    const { data: { data } = {} } = await request.post(
      '/game-server/general/guess',
      { guessedLatitude: lat, guessedLongitude: lng },
    );
    setGeneralModeResult(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [postGeneralResult]', error);
  }
};

export const getRandomFact = async () => {
  try {
    const { data: { data: { fact_text } = {} } = {} } =
      await request.get('/facts/random');
    setRandomFact(fact_text);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getRandomFact]', error);
  }
};

type TMode = 'competitive' | 'general' | 'training';
export const getGameModeStatus = async (mode: TMode) => {
  try {
    const { data: { data = {} } = {} } = await request.get(
      `/game-server/status?mode=${mode}`,
    );
    if (mode === 'competitive') {
      if (data.final) setIsFinishedCompetition(true);
      setCompetitionModeStatus(data);
    } else if (mode === 'general') {
      setGeneralModeStatus(data);
    } else if (mode === 'training') {
      setTrainingModeStatus(data);
    }
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getGameModeStatus]', error);
  }
};

export const getTrainingModeData = async () => {
  try {
    const { data: { data } = {} } = await request.post(
      '/game-server/training/location',
    );
    setTrainingModeData(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getTrainingModeData]', error);
  }
};

export const postTrainingResult = async (lat: number, lng: number) => {
  try {
    const { data: { data } = {} } = await request.post(
      '/game-server/training/guess',
      { guessedLatitude: lat, guessedLongitude: lng },
    );
    setTrainingModeResult(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [postTrainingResult]', error);
  }
};
